import { GroupedMeetings, Meeting } from "@/types/meeting";
import _ from "lodash";

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleString("fr-FR", { month: "short" });
  const year = date.getFullYear();
  const dayName = date.toLocaleString("fr-FR", { weekday: "long" });
  return {
    day,
    dayName,
    month,
    year,
    formattedDate: `${dayName}, ${day} ${month} ${year}`,
  };
};

export { formatDate };

export function groupMeetingsByDate(meetings: Meeting[]): GroupedMeetings {
  const today = new Date().toISOString().split("T")[0];
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowDate = tomorrow.toISOString().split("T")[0];

  const grouped = meetings.reduce<GroupedMeetings>((acc, meeting) => {
    const date = meeting.meeting_date;

    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(meeting);
    return acc;
  }, {});

  const sortedGroups: GroupedMeetings = {};

  Object.keys(grouped)
    .sort((a, b) => {
      if (a === today) return -1;
      if (b === today) return 1;

      if (a === tomorrowDate) return -1;
      if (b === tomorrowDate) return 1;

      return new Date(a).getTime() - new Date(b).getTime();
    })
    .forEach((key) => {
      let groupName = key;

      if (key === today) {
        groupName = "global.today";
      } else if (key === tomorrowDate) {
        groupName = "global.tomorrow";
      } else {
        groupName = _.capitalize(
          new Date(key).toLocaleDateString("fr-FR", { weekday: "long" }) +
            ", " +
            new Date(key).toLocaleDateString("fr-FR")
        );
      }

      sortedGroups[groupName] = grouped[key];
    });

  return sortedGroups;
}
